import type { WidgetType } from '@/lib/analytics/widget/widget.type';
import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostRecentPinsConfig: WidgetType<typeof MediasWidget> = {
    title: 'chart.pinterest.widget_most_recent_pins',
    id: 'widget_most_recent_pins',
    noSortTypesSelect: true,
    size: SIZE_FULL,
    sortFields: ['created', 'engagement_rate', 'impressions', 'engagement_on_impression'],
    type: 'widget',
    element: MediasWidget
};
